import { render, staticRenderFns } from "./HeaderNavigation.vue?vue&type=template&id=210654e6&scoped=true&"
import script from "./HeaderNavigation.vue?vue&type=script&lang=js&"
export * from "./HeaderNavigation.vue?vue&type=script&lang=js&"
import style0 from "./_HeaderNavigation.scss?vue&type=style&index=0&id=210654e6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210654e6",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ManageInvitations: require('/opt/components/ManageInvitations.vue').default,UserAvatar: require('/opt/components/user-avatar/UserAvatar.vue').default,LanguageSelector: require('/opt/components/LanguageSelector.vue').default})
